import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { WrappedApp } from "App";
import "core/utils/include/bootstrap.min.css"
import "./index.scss";

import * as serviceWorker from "./serviceWorker";
import "core/utils/windowObj";

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<div></div>}>
      <WrappedApp />
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

// registers the notifications service woker
serviceWorker.register();
